/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const CapsLockOn = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 20 20">
      <g fill="none" fillRule="evenodd">
        <path
          d="M9.781 3.046a.555.555 0 01.624.13l3.428 3.6a.622.622 0 010 .848.55.55 0 01-.808 0L10.57 5.049V14.4c0 .331-.255.6-.571.6-.316 0-.572-.269-.572-.6V5.05L6.976 7.624a.55.55 0 01-.808 0A.61.61 0 016 7.2c0-.153.056-.307.168-.425l3.427-3.598a.566.566 0 01.186-.131"
          fill="#3C3C3C"
        />
        <rect stroke="#3C3C3C" x={0.5} y={0.5} width={19} height={19} rx={4} />
        <path d="M6 16.5h8" stroke="#3C3C3C" strokeLinecap="square" />
      </g>
    </BaseSvgIcon>
  )
}

export default CapsLockOn
